import { typefacePickerHref, typefaceSample } from "@stackje/site-builder/type-pairings";
import { TYPEFACE_IDS, type Typeface } from "../api/contract";

/**
 * How each type style looks when the owner chooses brand guidelines. Raw designs decide how to
 * realize the selected family in their own CSS. Samples come from the shared pairing catalog so the
 * picker matches what the design agent is allowed to load.
 */
export const TYPEFACE_SAMPLES: Record<Typeface, { name: string; description: string; display: string; body: string; weight: number; href: string }> = Object.fromEntries(
  TYPEFACE_IDS.map((id) => {
    const sample = typefaceSample(id);
    return [id, { name: sample.name, description: sample.description, display: sample.displayFamily, body: sample.bodyFamily, weight: sample.weight, href: sample.href }];
  }),
) as Record<Typeface, { name: string; description: string; display: string; body: string; weight: number; href: string }>;

export const TYPEFACE_FONTS_HREF = typefacePickerHref();
